import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';

const CornerIndicator = ({ title, label, labelSx, sx, position }) => (
    <Tooltip title={title}>
        <Box
            component="span"
            sx={{
                position: 'absolute',
                top: position.top,
                left: position.left,
                width: 28,
                height: 28,
                bgcolor: '#1B357C',
                clipPath: 'polygon(0 0, 100% 0, 0 100%)',
                zIndex: 1,
                ...sx
            }}
        >
            <Box
                component="span"
                sx={{
                    position: 'absolute',
                    top: 2,
                    left: 3,
                    fontSize: '10px',
                    fontWeight: 600,
                    lineHeight: 1,
                    color: '#fff',
                    ...labelSx
                }}
            >
                {label}
            </Box>
        </Box>
    </Tooltip>
);

CornerIndicator.propTypes = {
    title: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    labelSx: PropTypes.object,
    sx: PropTypes.object,
    position: PropTypes.shape({
        top: PropTypes.number,
        left: PropTypes.number
    })
};

CornerIndicator.defaultProps = {
    labelSx: {},
    sx: {},
    position: {
        top: 0,
        left: -15
    }
};

export default CornerIndicator;
